import { find, findAll } from "../utils/dom";
import Swiper from "swiper";
import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

const PageSalaoDeCha = () =>{
	const page = find(`[js-page='salao-de-cha']`);
	if(!page) return;

	const $ = {
		btSlideTo: findAll("[js-slide-to]")
	}

	const resetButtonSlideTo = () =>{
		const bts = $.btSlideTo;
		if(!bts) return;

		bts.forEach((bt)=>{
			bt.classList.remove('active');
		})
	}

	const salao_de_cha = new Swiper(".swiper-salao-de-cha", {
		slidesPerView: 1,
		spaceBetween: 1,
		mousewheel: false,
		simulateTouch: false,
	});

	

	const btsSlideTo = () =>{
		const bts = $.btSlideTo;
		if(!bts) return;

		bts.forEach((bt)=>{
			bt.addEventListener("click", (e)=>{
				const index = e.target.getAttribute('js-slide-to');
				salao_de_cha.slideTo(index);
				resetButtonSlideTo();
				e.target.classList.add('active');
			})
		})
	}
	btsSlideTo();

	


	const url = new URL(window.location.href);
	const pagina = url.searchParams.get('pagina');

	if(pagina == 2){
		salao_de_cha.slideTo(pagina);
		resetButtonSlideTo();
		$.btSlideTo[1].classList.add("active");
	}



	Fancybox.bind("[data-fancybox]", {
		Thumbs: {
      autoStart: true,
    },
	});

	/*
	const salao_de_cha_item = new Swiper(".swiper-salao-de-cha-item",{
		slidesPerView: 1,
		navigation: {
			nextEl: ".swiper-button-next-salao-de-cha-item",
			prevEl: ".swiper-button-prev-salao-de-cha-item",
		},
		pagination: {
			el: ".swiper-pagination-salao-de-cha-item",
			clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '">' + (index + 1) + "</span>";
      },
		},
		
	})*/

	
}

export default PageSalaoDeCha;